
const en = {
    title: "Channels for Whistleblowing or Complaints",
    title1: "Complaint Form",
    language: "Language",
    back: "Back",
    submit: "Submit",
    cancel: "Cancel",
    form1: "Complaint Information",
    form2: "Date of The Complaint",
    form3: "Type of The Complaint",
    form4: "Project/Location",
    form5: "Department",
    form6: "The person who is being complained about (Name-Surname)",
    form7: "Date of Incident",
    form8: "Details",
    form9: "Attached file(s) (Doc, PDF, JPG, BMP)",
    form10: "more than 1 file",
    form11: "To be useful in contacting ",
    form12: "(This information will be anonymized)",
    form13: "",
    form14: "Name",
    form15: "Surname",
    form16: "E-Mail",
    form17: "Phone Number",
    form18: "I have read and accepted the Privacy Notice and Whistleblowing or Complaints Regulations. I hereby certify that I am of legal age and the personal data provided is accurate.",
    form19: "Title Complaint",
    form20: "1 file not more than 30 mb",
    footer1: "HEAD OFFICE",
    footer2: "DTGO CORPORATION LIMITED",
    footer3: "695 Moo 12, Bang Kaeo,",
    footer4: "Bang Phli, Samut Prakan 10540 Thailand",
    footer5: "Tel :",
    footer6: "+66 (0) 2 088 6400",
    textarea: "Could you please tell me more about the person, location, and incident? together with the results that follow",
    textarea1: "dd/mm/yyyy",
    confirmtitle: "Confirmation !",
    confirmsubmit: "You confirm that you will report the complaint.",
    confirmcancel: "You confirm that you have canceled the complaint.",
    ok: "OK",
    cancel: "CANCEL",
    success1: "Complaint Completed",
    success2: "Your complaint reference",
    success3: "Contact us",
    optiondata1: "Actions in conflict with the laws, policies, rules, regulations, or procedures of DTGO.",
    optiondata2: "Actions that constitute fraud or corruption.",
    optiondata3: "Applying or not exercising authority for personal benefit or to benefit family members or others",
    optiondata4: "Others than 1-3",
    texterror1: "Require!",
    texterror2: "Please enter a valid email address.",
    texterror3: "Phone number must start with 0.",
    texterror4: "Phone number must be between 9 and 10 digits.",
    texterror5: "Maximum file size limit is 30 MB",
    
}
const th = {
    title: "ช่องทางการแจ้งเบาะแสหรือข้อร้องเรียน",
    title1: "แบบฟอร์มข้อร้องเรียน",
    language: "ภาษา",
    back: "กลับ",
    submit: "ส่งเรื่องร้องเรียน",
    cancel: "ยกเลิก",
    form1: "ข้อมูลร้องเรียน",
    form2: "วันที่ร้องเรียน",
    form3: "ประเภทเรื่องร้องเรียน",
    form4: "โครงการ/สถานที่เกิดเหตุ",
    form5: "หน่วยงานที่ต้องการร้องเรียน",
    form6: "บุคคลที่ต้องการร้องเรียน",
    form7: "วันที่พบเหตุ",
    form8: "รายละเอียดเรื่องที่ร้องเรียน",
    form9: "แนบเอกสาร (Doc, PDF, JPG, BMP)",
    form10: "สามารถแนบเอกสารได้มากกว่า 1 ไฟล์",
    form11: "ข้อมูลผู้ร้องเรียน",
    form12: "เพื่อเป็นประโยชน์ในการติดต่อ",
    form13: "(ข้อมูลดังต่อไปนี้จะถูกปิดบังตัวตน)",
    form14: "ชื่อ",
    form15: "นามสกุล",
    form16: "อีเมล",
    form17: "เบอร์ติดต่อ",
    form18: "ข้าพเจ้าได้อ่านและยอมรับนโยบายรักษาความเป็นส่วนตัว และระเบียบการแจ้งเบาะแสหรือข้อร้องเรียน กลุ่มบริษัทดีทีจีโอ และขอรับรองว่าข้าพเจ้าเป็นผู้บรรลุนิติภาวะและข้อมูลส่วนบุคคลข้างต้นเป็นความจริง",
    form19: "เรื่องร้องเรียน",
    form20: "1ไฟล์ไม่เกิน 30 mb",
    footer1: "สำนักงานใหญ่",
    footer2: "บริษัท ดีทีจีโอ คอร์ปอเรชั่น จำกัด",
    footer3: "เลขที่ 695 หมู่ที่ 12 ตำบลบางแก้ว อำเภอบางพลี",
    footer4: "สมุทรปราการ 10540 ประเทศไทย",
    footer5: "หมายเลขโทรศัพท์ :",
    footer6: "+66 (0) 2 088 6400",
    textarea: "รายละเอียดบุคคล สถานที่ เหตุการณ์ที่เกิดขึ้น และผลกระทบที่เกิดขึ้น",
    textarea1: "วว/ดด/ปป",
    confirmtitle: "ยืนยันเรื่องร้องเรียน !",
    confirmsubmit: "คุณยืนยันที่จะแจ้งเรื่องร้องเรียน",
    confirmcancel: "คุณยืนยันที่ยกเลิกการแจ้งเรื่องร้องเรียน",
    ok: "ตกลง",
    cancel: "ยกเลิก",
    success1: "ข้อร้องเรียนถูกบันทึกเรียบร้อยแล้ว",
    success2: "รหัสเรื่องร้องทุกข์ของคุณ",
    success3: "ช่องการติดต่อ COS Office",
    optiondata1: "การปฏิบัติงานที่ไม่เป็นไปตามนโยบาย ระเบียบ ข้อบังคับของกลุ่มบริษัทดีทีจีโอ",
    optiondata2: "การกระทำที่เข้าข่ายการทุจริต หรือคอร์รัปชัน",
    optiondata3: "การใช้อำนาจ หรือละเว้นการปฏิบัติหน้าที่ เพื่อเอื้อประโยชน์ให้แก่ตนเองและผู้อื่น",
    optiondata4: "กรณีอื่นๆ นอกจากข้อ 1-3",
    texterror1: "กรุณากรอก",
    texterror2: "กรุณากรอก email ของท่าน",
    texterror3: "กรุณากรอกเบอร์ติดต่อที่ขึ้นต้นด้วย 0",
    texterror4: "กรุณากรอกเบอร์ติดต่อ 9 หรือ 10 หลัก",
    texterror5: "ขีดจำกัดขนาดไฟล์สูงสุดคือ 30 MB",
}
export const textKey = {
    BACK: "back",
    TITLE: "title",
    TITLE1: "title1",
    LANGUAGE: "language",
    SUBMIT: "submit",
    CANCEL: "cancel",
    FORM1: "form1",
    FORM2: "form2",
    FORM3: "form3",
    FORM4: "form4",
    FORM5: "form5",
    FORM6: "form6",
    FORM7: "form7",
    FORM8: "form8",
    FORM9: "form9",
    FORM10: "form10",
    FORM11: "form11",
    FORM12: "form12",
    FORM13: "form13",
    FORM14: "form14",
    FORM15: "form15",
    FORM16: "form16",
    FORM17: "form17",
    FORM18: "form18",
    FORM19: "form19",
    FORM20: "form20",
    FOOTER1: "footer1",
    FOOTER2: "footer2",
    FOOTER3: "footer3",
    FOOTER4: "footer4",
    FOOTER5: "footer5",
    FOOTER6: "footer6",
    TEXTAREA: "textarea",
    TEXTAREA1: "textarea1",
    CONFIRMTITLE: "confirmtitle",
    CONFIRMSUBMIT: "confirmsubmit",
    CONFIRMCANCEL: "confirmcancel",
    OK: "ok",
    CANCEL: "cancel",
    SUCCESS1: "success1",
    SUCCESS2: "success2",
    SUCCESS3:"success3",
    OPTIONDATA1: "optiondata1",
    OPTIONDATA2: "optiondata2",
    OPTIONDATA3: "optiondata3",
    OPTIONDATA4: "optiondata4",
    TEXTERROR1: "texterror1",
    TEXTERROR2: "texterror2",
    TEXTERROR3: "texterror3",
    TEXTERROR4: "texterror4",
    TEXTERROR5: "texterror5",
}






export const getTextResult = (key) => {

    const lang = localStorage.getItem('language')

    if (lang == "th") {
        return th[key]
    } else {
        return en[key]
    }

}